import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {LineupsMemberStatsDomainModel} from "./lineups-member.stats.domain-model";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export class LineupsMemberStatsViewModel extends BaseViewModel {
  domainModel: LineupsMemberStatsDomainModel;

  get type(): Number {
    return this.domainModel.type;
  }

  get value(): String {
    return this.domainModel.value;
  }

  get isTop(): Boolean {
    return this.domainModel.isTop;
  }

  get categoryId(): Number {
    return this.domainModel.categoryId;
  }

  get shortName(): String {
    return this.domainModel.shortName || this.domainModel.name;
  }

  get order(): Number {
    return this.domainModel.order;
  }

  get imageId(): Number {
    return this.domainModel.imageId;
  }
  get color(): String {
    let color: String = null;
    switch (this.imageId) {
      case 229: //game-time
        color = useThemeColor(COLORS.dangerPrimary)
        break;
      case 225: //assists
        color = useThemeColor(COLORS.accentPrimary)
        break;
      case 226: //rating star
        color = useThemeColor(COLORS.textPrimary)
        break;
      default:
      // code block
    }
    return color;
  }
}